<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Edit Message</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickSave"
                >
                    Save &amp; Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-row>
                <v-col style="flex-grow: 1">
                    <v-select
                        label="By"
                        :items="endpoints"
                        item-text="label"
                        item-value="endpoint"
                        return-object
                        v-model="new_message_before_by"
                    />
                </v-col>

                <v-col style="flex-grow: 6">
                    <v-text-field
                        autocomplete="off"
                        label="New Message Before"
                        v-model="new_message_before"
                    />
                </v-col>
            </v-row>

            <v-text-field
                v-if="text != null"
                autocomplete="off"
                
                label="Message"
                v-model="text"
            />

            <v-row>
                <v-col style="flex-grow: 1">
                    <v-select
                        label="By"
                        :items="endpoints"
                        item-text="label"
                        item-value="endpoint"
                        return-object
                        v-model="new_message_after_by"
                    />
                </v-col>

                <v-col style="flex-grow: 6">
                    <v-text-field
                        label="New Message After"
                        v-model="new_message_after"
                        autocomplete="off"
                    />
                </v-col>
            </v-row>


            <div
                style="text-align: right" 
            >
                <v-btn
                    style="margin-right: 15px"
                    v-on:click="onClickDiscardChanges"
                >
                    Cancel
                </v-btn>

                <v-btn
                    style="margin-right: 15px"
                    color="primary"
                    v-on:click="onClickSave"
                >
                    Save
                </v-btn>
            </div>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            message: null,

            text: null,
            dialog: false,
            is_valid: true,
            endpoints: [],

            new_message_after_by: null,
            new_message_after: null,

            new_message_before_by: null,
            new_message_before: null,
        }
    },

    methods: {

        showDialog(message)
        {
            this.message = message;
            this.text = message.getContent();
            this.endpoints = null;

            this.new_message_after = null;
            this.new_message_before = null;

            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;



            this.getEndpoints();
        },

        getEndpoints()
        {
            this.$rc.newGetConversation(
                this.message.getConversationId(),
                true,
            
                (data) => {
                    this.endpoints = data.endpoint_sumamries;
                    this.new_message_after_by = this.endpoints[0];
                    this.new_message_before_by = this.endpoints[0];
                },
            
                () => {
                    this.$rc.alert('Error','Unable to get conversation endpoints');
                },
            );

            
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            // The dialog is showing...
            if ( this.is_valid )
            {
                // data is valid, so save 
                this.save();
                this.dialog = false;
                next(false);
                return;
            }
        
            this.$rc.snackbar('You must either correct the errors or discard your changes.',1500);
            this.dialog = true;
            next(false);
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        save()
        {
            this.saveMessage();
            this.saveAfter();
            this.saveBefore();
        },

        saveMessage()
        {
            if ( this.message.getContent() == this.text )
                return;

            // Delete?
            if ( this.text.trim().length == 0 )
            {
                this.$rc.rest({
                    'spinner': true,
                    'endpoint': 'DELETE: /api/v1/admin/stored-message/:message_id',
                
                    'params' : {
                            'message_id': this.message.getMessageId(),
                        },
                
                    'on_success': (data) => {
                            this.$rc.snackbar('Message deleted');
                        },
                
                    'on_error': 'Unable to delete message',
                });

                return;
            }

            // EDIT
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'SET-CONTENT: /api/v1/admin/stored-message',
            
                'params' : {
                        'stored_message_id': this.message.getMessageId(),
                        'content': this.text,
                    },
            
                'on_success': (data) => {
                        
                    },
            
                'on_error': 'Unable to edit message content',
            });
        },

        saveAfter()
        {
            this.saveNewMessage(this.new_message_after_by.endpoint, this.new_message_after, true);
        },

        saveBefore()
        {
            this.saveNewMessage(this.new_message_before_by.endpoint, this.new_message_before, false);
        },

        saveNewMessage(endpoint, message, before)
        {
            if ( message == null || message.trim().length == 0 )
                return;

            let data = {
                'conversation_id' : this.message.getConversationId(),
                'endpoint' : endpoint,
                'content' : message,
            };

            if ( before )
                data.before = this.message.getMessageId();
            else
                data.after = this.message.getMessageId();
            
            this.$rc.adminNewStoredMessage(
                data,
            
                (data) => {
                },
            
                () => {
                    this.$rc.alert('Error','Unable to add message');
                },
            );
            
        },

    },
}
</script>

<style lang="scss" scoped>
</style>